/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async searchSystem(keyword) {
    let data = { hint: keyword };
    let response = await apiCall("system/search", data);
    return response;
  },

  /**
   * Result types include:- 
   * - student  
	 * - staff  
	 * - report  
   */
  async logItem(log_id, result_type, title, subtitle, content) {
    let data = { 
      log_id:log_id,
      result_type:result_type,
      title:title,
      subtitle:subtitle,
      content: content
    }
     
    let response = await apiCall("system/searchresult/create", data);
    return response;
  },

  async fetchRecentSearch() {
    let response = await apiCall("system/finder/recent", []);
    return response;
  },

  async fetchSearchSuggestions() {
    let response = await apiCall("system/searchresult/suggestions", []);
    return response;
  },
  

};
